import { Component, ElementRef, HostListener, Input } from '@angular/core';

@Component({
  selector: 'app-tooltip-info',
  standalone: false,
  templateUrl: './tooltip-info.component.html',
  styleUrl: './tooltip-info.component.scss'
})
export class TooltipInfoComponent {
  @Input() text = '';
  @Input() ariaLabel = 'More information';

  isOpen = false;

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  onMouseEnter() {
    this.isOpen = true;
  }

  onMouseLeave() {
    this.isOpen = false;
  }

  onToggle(event: Event) {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as Node | null;
    if (!target) return;
    if (this.elementRef.nativeElement.contains(target)) return;
    this.isOpen = false;
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    this.isOpen = false;
  }
}
